import {createReducer} from "./index";
import {
  ADD_BID_CALENDAR,
  ADD_BID_STATUSES,
  ADD_DAILY_LOG_CALENDAR, ADD_DAILY_LOG_DETAILS,
  ADD_DAILY_LOG_STATUSES, ADD_MEETING_MINUTES_DETAILS,
  ADD_PROJECT_CALENDAR,
  ADD_PROJECT_RFI_CALENDAR,
  ADD_PROJECT_RFI_DETAILS,
  ADD_PROJECT_RFI_STATUSES,
  ADD_PROJECT_STATUSES,
  ADD_PUNCH_CALENDAR,
  ADD_PUNCH_STATUSES,
  ADD_SUBMITTAL_CALENDAR,
  ADD_SUBMITTAL_DETAILS,
  ADD_SUBMITTAL_STATUSES,
  ADD_TASK_CALENDAR,
  ADD_TASK_DETAILS,
  ADD_TASK_STATUSES,
  ADD_UPCOMING_BID_DETAILS
} from "../actions/reports";
import * as R from 'ramda';
import Moment from 'moment';

const reportsInitial = {
  details: {},
  by_status: {},
  calendar: {},
};

/*
Structure of reports model:

{
  details: {
    upcomingbids: {
      resource: [],
      cache: {
        loading: false,
        fetched: null,
        error: null,
      }
    },
    projectrfis: {
      resource: [],
      indexes: {},
      cache: {
        loading: false,
        fetched: null,
        error: null,
      }
    },
    submittals: {
      resource: [],
      indexes: {},
      cache: {
        loading: false,
        fetched: null,
        error: null,
      }
    },
    tasks: {
      resource: [],
      indexes: {},
      cache: {
        loading: false,
        fetched: null,
        error: null,
      }
    },
  },
  by_status: {
    bids: {
      resource: [
        status: str,
        count: int,
      ],
      cache: {
        loading: false,
        fetched: null,
        error: null,
      }
    },
    projects: {
      resource: [
        status: str,
        count: int,
      ],
      cache: {
        loading: false,
        fetched: null,
        error: null,
      }
    },
    projectrfis: {
      resource: [
        status: str,
        count: int,
      ],
      indexes: {},
      cache: {
        loading: false,
        fetched: null,
        error: null,
      }
    },
    submittals: {
      resource: [
        status: str,
        count: int,
      ],
      indexes: {},
      cache: {
        loading: false,
        fetched: null,
        error: null,
      }
    },
    tasks: {
      resource: [
        status: str,
        count: int,
      ],
      indexes: {},
      cache: {
        loading: false,
        fetched: null,
        error: null,
      }
    },
    punches: {
      resource: [
        status: str,
        count: int,
      ],
      indexes: {},
      cache: {
        loading: false,
        fetched: null,
        error: null,
      }
    },
  },
}

 */

function statusReducer(state, action, path, sorter = null) {
  let newState = state;
  action.payload.forEach(report => {
    if (sorter) report.sort(sorter);
    const newData = { resource: report, cache: { loading: false, fetched: Moment(), error: null, } };
    newState = R.set(R.lensPath(path.slice(0, 2)), newData, newState);
  });
  return newState;
}

function detailReducer(state, action, path) {
  let newState = state;
  action.payload.forEach(report => {
    const newData = { resource: report, cache: { loading: false, fetched: Moment(), error: null, } };
    newState = R.set(R.lensPath(path('').slice(0, 2)), newData, newState);
    report.forEach(item => {
      newState = R.over(R.lensPath(path(item).slice(0, 5)), value => {
        if (!value) return {[item.id]: 1};
        else return {...value, [item.id]: 1};
      })(newState)
    })
  });
  return newState;
}

const reportsReducer = createReducer(reportsInitial,
  {
    // 'ACTION_NAME': function (state, action) -> new_state
    [ADD_BID_STATUSES]: (state, action) => statusReducer(state, action, ['by_status', 'bids']),
    [ADD_PROJECT_STATUSES]: (state, action) => statusReducer(state, action, ['by_status', 'projects']),
    [ADD_PROJECT_RFI_STATUSES]: (state, action) => statusReducer(state, action, ['by_status', 'projectrfis']),
    [ADD_SUBMITTAL_STATUSES]: (state, action) => statusReducer(state, action, ['by_status', 'submittals']),
    [ADD_TASK_STATUSES]: (state, action) => statusReducer(state, action, ['by_status', 'tasks']),
    [ADD_PUNCH_STATUSES]: (state, action) => statusReducer(state, action, ['by_status', 'punches']),
    [ADD_DAILY_LOG_STATUSES]: (state, action) => statusReducer(state, action, ['by_status', 'dailylogs']),
    [ADD_BID_CALENDAR]: (state, action) => statusReducer(state, action, ['calendar', 'bids']),
    [ADD_PROJECT_CALENDAR]: (state, action) => statusReducer(state, action, ['calendar', 'projects']),
    [ADD_PROJECT_RFI_CALENDAR]: (state, action) => statusReducer(state, action, ['calendar', 'projectrfis']),
    [ADD_SUBMITTAL_CALENDAR]: (state, action) => statusReducer(state, action, ['calendar', 'submittals']),
    [ADD_TASK_CALENDAR]: (state, action) => statusReducer(state, action, ['calendar', 'tasks']),
    [ADD_PUNCH_CALENDAR]: (state, action) => statusReducer(state, action, ['calendar', 'punches']),
    [ADD_DAILY_LOG_CALENDAR]: (state, action) => statusReducer(state, action, ['calendar', 'dailylogs']),
    [ADD_UPCOMING_BID_DETAILS]: (state, action) => statusReducer(state, action, ['details', 'upcomingbids'], (a, b) => Moment(a.bidduedatetime) - Moment(b.bidduedatetime)),
    [ADD_PROJECT_RFI_DETAILS]: (state, action) => detailReducer(state, action, (item) => ['details', 'projectrfis', 'indexes', 'projectid', item.projectid]),
    [ADD_SUBMITTAL_DETAILS]: (state, action) => detailReducer(state, action, (item) => ['details', 'submittals', 'indexes', 'projectid', item.projectid]),
    [ADD_TASK_DETAILS]: (state, action) => detailReducer(state, action, (item) => ['details', 'tasks', 'indexes', 'projectid', item.projectid]),
    [ADD_DAILY_LOG_DETAILS]: (state, action) => detailReducer(state, action, (item) => ['details', 'dailylogs', 'indexes', 'projectid', item.projectid]),
    [ADD_MEETING_MINUTES_DETAILS]: (state, action) => detailReducer(state, action, (item) => ['details', 'meetingminutes', 'indexes', 'projectid', item.projectid]),
  });

export default reportsReducer;



// WEBPACK FOOTER //
// ./src/reducers/reports.js